document.querySelectorAll('.faq-item__trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    const answerId = trigger.getAttribute('aria-controls');
    const answer = document.getElementById(answerId);

    trigger.setAttribute('aria-expanded', String(!expanded));
    if (answer) answer.hidden = expanded;
  });
});
